/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var __ = wp.i18n.__;
var _x = wp.i18n._x;
var _n = wp.i18n._n;
var _nx = wp.i18n._nx;
var vtx_colors = {
  danger: '#dc3545'
};
var get_header_height = function get_header_height() {
  return jQuery('.navbar').height();
};
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function init() {
        // detects if user is using the keyboard to navigate and if so, adds a class to body
        function handleFirstTab(e) {
          if (e.keyCode === 9 || e.keyCode === 32 || e.keyCode === 13 || e.keyCode === 37 || e.keyCode === 39) {
            // the "I am a keyboard user" key
            document.body.classList.add('user-is-tabbing');
            window.removeEventListener('keydown', handleFirstTab);
          }
        }
        window.addEventListener('keydown', handleFirstTab);

        /* -- initial scroll body */
        function initScrollBody() {
          var scrolltop = $(window).scrollTop();
          if (scrolltop > 150) {
            $("header").addClass("sticky");
            $("body").addClass("sticky");
          } else {
            $("header").removeClass("sticky");
            $("body").removeClass("sticky");
          }
        }
        $(window).on('scroll', function () {
          // selectors
          var $window = $(window),
            $body = $('body'),
            $panel = $('.color-effect');
          $test = $('.block-highlight');
          $letter = $(".list__scroll__item");

          // Change 33% earlier than scroll position so colour is there when you arrive.
          var scroll = $window.scrollTop() + $window.height();
          $panel.each(function () {
            var $this = $(this);
            // if position is within range of this panel.
            // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
            // Remember we set the scroll to 33% earlier in scroll var.
            if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
              // Remove all classes on body with color-
              $body.removeClass(function (index, css) {
                return (css.match(/(^|\s)color-\S+/g) || []).join(' ');
              });

              // Add class of currently active div
              $body.addClass('color-' + $(this).data('color'));
              $letter.css("color", "#062c53");
              $letter.css("-webkit-text-stroke-color", "#062c53");
            }
          });
        });
        window.onscroll = function () {
          initScrollBody();
        };
        window.onload = function () {
          initScrollBody();
        };
        AOS.init({
          once: true,
          anchorPlacement: 'top-top'
        });

        //credits..
        // console.log(
        //   '%c  \n' +
        //   '%cVortex Solution \n' +
        //   'https://www.vortexsolution.com',
        //   'font-size:30px; background: #fff url(https://www.vortexsolution.com/wp-content/themes/vortex-solution/assets/favicon/favicon-32x32.png) no-repeat; color:#fff;',
        //   'background: #fff; color:#00a6e9;font-weight:bold;'
        // );

        /*--- Link anchor smooth scrool --*/
        (function ($) {
          $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
              var $target = $(this.hash);
              $target = $target.length ? $target : $('[name=' + this.hash.slice(1) + ']');
              if ($target.length) {
                event.preventDefault();
                $('html, body').stop().animate({
                  scrollTop: $target.offset().top - get_header_height() - 50
                }, 1000, function () {
                  return false;
                });
              }
            }
          });

          // At load.
          if (window.location.hash) {
            var $target = $(window.location.hash);
            if ($target.length) {
              $('html, body').stop().animate({
                scrollTop: $target.offset().top - get_header_height() - 100
              }, 0, function () {
                return false;
              });
            }
          }
        })(jQuery);
        function deactivate_facets_if_empty() {
          $('.facetwp-facet.deactivated').removeClass('deactivated');
          for (var facet_name in FWP.settings.num_choices) {
            if (0 === FWP.settings.num_choices[facet_name]) {
              $(".facetwp-facet-".concat(facet_name)).addClass('deactivated');
            }
          }
        }
        $(document).on('facetwp-loaded', function () {
          deactivate_facets_if_empty();
        });
        $(function () {
          if ('undefined' !== typeof FWP) {
            deactivate_facets_if_empty();
          }
        });
      },
      finalize: function finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function init() {
        // JavaScript to be fired on the home page

        function isVisible(elment) {
          var vpH = $(window).height(),
            // Viewport Height
            st = $(window).scrollTop(),
            // Scroll Top
            y = $(elment).offset().top;
          return y <= vpH + st;
        }
        function setSideNotePos() {
          $(window).scroll(function () {
            if (isVisible($('.site-footer'))) {
              $('.fix-bar').css('position', 'absolute');
              $('.fix-bar').css('bottom', '0');
              $('.fix-bar').css('top', 'auto');
              // $('.collapsable-newsletter-wrapper').css('top', $('.site-footer').offset().top - $('.collapsable-newsletter-wrapper').outerHeight() - 100);
            } else {
              $('.fix-bar').css('position', 'fixed');
              $('.fix-bar').css('bottom', 'auto');
            }
          });
        }
        setSideNotePos();
      },
      finalize: function finalize() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function init() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function fire(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function loadEvents() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

/**
 * Identical as possible to the PHP helper version.
 * 
 * @param {array} strings - Array of strings to implode together.
 * @param {bool} $wrap_strings_in_span - Wrap all the imploded strings in a span. They do not wrap the delimiter.
 *
 * @return {string} A phrase that may look like: This, that and those.
 *
 * @author Marc-André De Launière
 */
function implode_with_synthax(strings) {
  var wrap_strings_in_span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = '';
  var nb = strings.length;
  if (nb) {
    for (var i = 0; i < nb; i++) {
      // Only apply synthax logic to other than the first item.
      if (html) {
        if (i === nb - 1) {
          html += _x(' and ', 'Between the two last items of a list', 'vtx');
        } else {
          html += _x(', ', 'Between two items of a list that are not last', 'vtx');
        }
      }
      if (wrap_strings_in_span) {
        html += "<span>".concat(strings[i], "</span>");
      } else {
        html += strings[i];
      }
    }
  }
  return html;
}